const CicleCheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="circle-check"
        d="M13.3086 7.05859L8.75 11.6172L6.69141 9.55859C6.44727 9.31445 6.05156 9.31445 5.80781 9.55859C5.56406 9.80273 5.56367 10.1984 5.80781 10.4422L8.30781 12.9422C8.42969 13.0625 8.58984 13.125 8.75 13.125C8.91016 13.125 9.06984 13.064 9.1918 12.9419L14.1918 7.94187C14.4359 7.69773 14.4359 7.30203 14.1918 7.05828C13.9477 6.81453 13.5508 6.8125 13.3086 7.05859ZM10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 18.75C5.17578 18.75 1.25 14.8242 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 14.8242 14.8242 18.75 10 18.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CicleCheckIcon;
